import {IntBackLightingTemplate} from "../../types";

export function backLightingReplacer(str: string, templates: Array<IntBackLightingTemplate>) {
  const tokens = templates.filter(t => Boolean(t.token)).map(t => t.token).join('|')
  const regexp = new RegExp(`${tokens}`, 'gim');
  return str.replace(regexp, (match) => {
    const template = templates.find(({token}) => {
      return token.toLowerCase() === match.toLowerCase();
    });
    return `<span style="${getStyles(template)}">${match}</span>`
  });
}

function getStyles(template: IntBackLightingTemplate | undefined) {
  return `background-color: ${template?.backgroundColor}; color: ${template?.color || 'inherit'}; border-radius: 0.2em; padding: 0.1em 0.2em;`
}
